export function objectToFormData(obj: any, rootName: string = ''): FormData {

    var formData = new FormData();

    const appendFormData = (data: any, root: any) => {
        root = root || '';
        if (data instanceof File) {
            formData.append(root, data);
        } else if (Array.isArray(data)) {
            for (var i = 0; i < data.length; i++) {
                appendFormData(data[i], root + '[' + i + ']');
            }
        } else if (typeof data === 'object' && data) {
            for (var key in data) {
                if (data.hasOwnProperty(key)) {
                    if (root === '') {
                        appendFormData(data[key], key);
                    } else {
                        appendFormData(data[key], root + '.' + key);
                    }
                }
            }
        } else {
            if (data !== null && typeof data !== 'undefined') {
                formData.append(root, data);
            }
        }
    }

    appendFormData(obj, rootName);
    return formData;
}

export function objectToQueryString(obj: any, ...params: string[]): string {
    const query = require('querystring');
    let queryString = query.stringify(obj) as string;
    if (params) {
        for (var i = 0; i < params.length; i++) {
            queryString += `&${params[i]}`;
        }
    }
    return queryString;
}

export function downloadBlob(blob: Blob, fileName?: string) {
    var url = window.URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    if (fileName) {
        a.download = fileName;
    }
    document.body.appendChild(a);
    a.click();
    a.remove();
}